<svg viewBox="0 0 407.1 40">
    <polygon
        class="pattern_st0"
        points="114.76,0.46 106.59,20.06 0.06,20.06 0.06,0.46 "
    />
    <polygon
        class="pattern_st1"
        points="57.54,20.06 49.37,39.66 0,39.66 0,20.06 "
    />
</svg>
